import Marquee from "react-fast-marquee";

const WORDS = [
  "PREMIUM LASER ENGRAVING",
  "PRECISION · PURPOSE · PERSONAL",
  "CUSTOM CRAFTED",
  "MARKED TO LAST",
];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-strip" className="py-10 border-y border-white/10 bg-black overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-4xl md:text-6xl px-8 text-foreground/90">
              {w}
            </span>
            <span className="text-primary text-3xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
